var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataScience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1080 1112.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-data-science--lg-1",
    x1: 983.3421,
    x2: 137.5978,
    y1: 33.8125,
    y2: 33.8125,
    gradientTransform: "translate(0 482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b17ae"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-data-science--lg-2",
    x1: 983.3421,
    x2: 137.5978,
    y1: 33.7625,
    y2: 33.7625,
    gradientTransform: "translate(0 482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b17ae"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-data-science--lg-3",
    x1: 287.8815,
    x2: 858.7589,
    y1: 224.9582,
    y2: 487.1389,
    gradientTransform: "translate(0 482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00398685,
    stopColor: "#098aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169582"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#098aed",
    d: "M849.1 165.6L581.7 11.2c-25.8-14.9-57.6-14.9-83.3 0L230.9 165.6c-25.8 14.9-41.7 42.4-41.7 72.2v308.8c0 29.8 15.9 57.3 41.7 72.2L378.4 704V565.5c0-29.8 15.9-57.3 41.7-72.2L540 424l119.9 69.2c25.8 14.9 41.7 42.4 41.7 72.2v138.5l147.5-85.2c25.8-14.9 41.7-42.4 41.7-72.2V237.7c0-29.7-15.9-57.2-41.7-72.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.3 493.3L770.9 338.9c-25.8-14.9-57.6-14.9-83.3 0L540 424l119.9 69.2c25.8 14.9 41.7 42.4 41.7 72.2v138.5l-119.9 69.2c-25.8 14.9-57.6 14.9-83.3 0l-119.9-69.2v170.4c0 29.8 15.9 57.3 41.7 72.2l267.5 154.4c25.8 14.9 57.6 14.9 83.3 0l267.5-154.4c25.8-14.9 41.7-42.4 41.7-72.2V565.5c-.2-29.8-16.1-57.3-41.9-72.2z",
    fill: "#41d3bd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M581.7 773.2c-25.8 14.9-57.6 14.9-83.3 0L378.5 704V565.5c0-29.8 15.9-57.3 41.7-72.2L540 424l-147.5-85.2c-25.8-14.9-57.6-14.9-83.3 0L41.7 493.3C15.9 508.2 0 535.7 0 565.5v308.8c0 29.8 15.9 57.3 41.7 72.2l267.5 154.4c25.8 14.9 57.6 14.9 83.3 0L660 946.5c25.8-14.9 41.7-42.4 41.7-72.2V703.9l-120 69.3z",
    fill: "#41d3bd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-data-science--lg-1)",
    d: "M770.9 338.9c-25.8-14.9-57.6-14.9-83.3 0L540 424l119.9 69.2c25.8 14.9 41.7 42.4 41.7 72.2v138.5l147.5-85.2c25.8-14.9 41.7-42.4 41.7-72.2V408.1l-119.9-69.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-data-science--lg-2)",
    d: "M378.4 703.9V565.5c0-29.8 15.9-57.3 41.7-72.2L540 424l-147.5-85.2c-25.8-14.9-57.6-14.9-83.3 0L189.3 408v138.5c0 29.8 15.9 57.3 41.7 72.2l147.4 85.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-data-science--lg-3)",
    d: "M581.7 773.2c-25.8 14.9-57.6 14.9-83.3 0L378.5 704v170.4c0 29.8 15.9 57.3 41.7 72.2l119.9 69.2L660 946.6c25.8-14.9 41.7-42.4 41.7-72.2V704l-120 69.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/data-science.ce5f3520.svg";
export { ForwardRef as ReactComponent };